import React from "react";

import { Modal } from "@samskip/frontend-components";
import { useTranslation } from "react-i18next";

import { CommonTypes } from "@assets/types";

interface DeleteItemModalProps {
  content?: string;
  title?: string;
  onClose: CommonTypes.CallbackFunction;
  handleDelete: CommonTypes.CallbackFunction;
}
const DeleteItemModal = ({
  content,
  title = "",
  onClose,
  handleDelete,
}: DeleteItemModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      closeIcon
      corner="sharp"
      divided
      onClose={onClose}
      open
      primaryButtonProps={{
        children: t("LABEL_DELETE"),
        onClick: handleDelete,
        variant: "error",
      }}
      secondaryButtonProps={{ children: t("LABEL_CANCEL"), onClick: onClose }}
      title={title}
    >
      {content}
    </Modal>
  );
};

export default DeleteItemModal;
